import { ChangeDetectionStrategy, Component, inject, Input, input, OnChanges, output, SimpleChanges } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatCheckbox } from '@angular/material/checkbox';
import { CartPrice } from '../../../../projects/shared-lib/src/lib/models/cart-price';
import { PriceLevels } from '../../../../projects/shared-lib/src/lib/models/price-levels';
import { ItemHour } from '../../../../projects/shared-lib/src/lib/models/item-hour';
import { PriceManagerService } from '../../page/services/price-manager.service';
import { PageSaleService } from '../../page/services/page-sale.service';
import { ClarityService } from '../../../../projects/shared-lib/src/lib/component/microsoftClarity/clarity.service';
import { ClarityEventType } from '../../../../projects/shared-lib/src/lib/component/microsoftClarity/clarity.types';
import { cloneObjectHelps } from '../../../../projects/shared-lib/src/lib/services';
import { JsonPipe } from '@angular/common';

@Component({
    selector: 'tw-template-qty',
    imports: [MatButton, MatIcon, MatCheckbox],
    templateUrl: './template-qty.component.html',
    styleUrl: './template-qty.component.scss',
})
export class TemplateQtyComponent {
    private readonly priceManagerService = inject(PriceManagerService);
    private readonly pageSaleService = inject(PageSaleService);
    private readonly clarityService = inject(ClarityService);

    @Input() price!: CartPrice;
    @Input() priceLevel: PriceLevels | undefined = undefined;

    readonly itemHour = input<ItemHour | undefined>(undefined);
    readonly validateMaxTickets = input(false);
    readonly maxQty = input(-1);
    readonly minQty = input(-1);
    readonly typeSelection = input<'checkbox' | 'multiple'>('multiple');
    readonly storeIdsSeat = input<any[]>([]);
    readonly storeIdsSeatChange = output<any[]>();
    readonly seatIds = input<any[]>([]);

    onCheckboxChange(checked: boolean): void {
        if (checked) {
            this.qtyPlusOne();
        } else {
            this.qtyMinusOne();
        }
    }

    qtyMinusOne(): void {
        const price = this.price;
        const priceLevel = this.priceLevel;

        if (priceLevel) {
            this.priceManagerService.qtyMinusOne(this.getFirstPrice(priceLevel));
            return;
        }
        const itemHour = this.itemHour();
        if (itemHour) {
            price.date = itemHour.dateOnly;
            price.hoursId = itemHour.expositionId;
        }
        const refPrice = price; //cloneObjectHelps(price);
        this.addAbandonedCartInfo(refPrice);
        if (this.seatIds().length > 0) {
            const currentSeatIds: any[] = refPrice.seatIds || [];
            const idToRemove = currentSeatIds.find((id: any) => this.seatIds().includes(id));
            if (idToRemove !== undefined) {
                refPrice.seatIds = currentSeatIds.filter((id: any) => id !== idToRemove);
                this.storeIdsSeatChange.emit([...this.storeIdsSeat(), idToRemove]);
            }
        }
        price.confirmed = true;

        this.priceManagerService.qtyMinusOne(refPrice);
    }

    qtyPlusOne(): void {
        const price = this.price;
        const priceLevel = this.priceLevel;

        if (priceLevel) {
            this.priceManagerService.qtyPlusOne(this.getFirstPrice(priceLevel));
            return;
        }
        const itemHour = this.itemHour();
        if (itemHour) {
            price.date = itemHour.dateOnly;
            price.hoursId = itemHour.expositionId;
        }
        const refPrice = price; //cloneObjectHelps(price);
        this.addAbandonedCartInfo(refPrice);
        if (this.seatIds().length > 0) {
            const storeIds = this.typeSelection() === 'checkbox' ? this.seatIds() : this.storeIdsSeat();
            const seatId = storeIds.at(-1);
            if (seatId !== undefined) {
                refPrice.seatIds = [...(refPrice.seatIds || []), seatId];
                this.storeIdsSeatChange.emit(storeIds.slice(0, -1));
            }
        }
        refPrice.confirmed = true;

        this.priceManagerService.qtyPlusOne(refPrice);
    }

    private getFirstPrice(priceLevel: PriceLevels): CartPrice {
        const priceInput = this.price;
        const p: CartPrice = priceInput || priceLevel.prices[0];
        this.addAbandonedCartInfo(p);
        const itemHour = this.itemHour();
        if (itemHour) {
            p.date = itemHour.dateOnly;
            p.hoursId = itemHour.expositionId;
        }
        if (priceLevel.prices.length === 1 || priceInput) {
            p.confirmed = true;
        }
        return p;
    }

    private addAbandonedCartInfo(price: CartPrice): void {
        try {
            const pageInfo = this.pageSaleService.page_subject.value;
            const itemHour = this.itemHour();
            if (price && pageInfo && price.abandonedCartActive) {
                price.pageUrl = window.location.href;
                price.imageUrl = pageInfo?.imageUrlBig;
                price.title = pageInfo?.title;
                if (itemHour) {
                    price.date = itemHour?.formattedDate;
                }
                price.venue = pageInfo?.locations[0]?.name;
            }
        } catch (e) {
            this.clarityService.trackErrorByType(ClarityEventType.ERROR_SYMPLIFY_PRICE, {}, window.location.href);
        }
    }

    getQtyForOnlySeatIdsSelected(): number {
        const price = this.price;
        const seatIds = this.seatIds();
        if (seatIds && seatIds.length > 0) {
            if (this.typeSelection() === 'checkbox') {
                if (price.seatIds && price.seatIds.length > 0) {
                    console.log(
                        '===============',
                        price.id,
                        price.seatIds,
                        seatIds,
                        price.seatIds.filter((id: any) => seatIds.includes(id)).length,
                    );
                    return price.seatIds.filter((id: any) => seatIds.includes(id)).length;
                }
                return 0;
            }
            if (price.seatIds && price.seatIds.length > 0) {
                const seatIds = this.seatIds();

                console.log(
                    '===============',
                    price.id,
                    price.seatIds,
                    seatIds,
                    price.seatIds.filter((id: any) => seatIds.includes(id)).length,
                );
                return price.seatIds.filter((id: any) => seatIds.includes(id)).length;
            }
        }

        return price.qty;
    }
    onCheckout(): boolean {
        const price = this.price;
        const seatIds = this.seatIds();
        if (price.seatIds && price.seatIds.length > 0) {
            return price.seatIds.filter((id: any) => seatIds.includes(id)).length === 1;
        }
        return false;
    }

    protected disabledPlusOne() {
        const price = this.price;
        const seatIds = this.seatIds();
        if (seatIds && seatIds.length > 0) {
            if (this.typeSelection() === 'checkbox') {
                return false;
            }
            return this.storeIdsSeat().length === 0;
        }
        return price.maxTickets == null || price.maxTickets === 0 ? false : price.qty >= price.maxTickets;
    }
    protected disabledMinusOne() {
        const price = this.price;
        const seatIds = this.seatIds();
        if (seatIds && seatIds.length > 0) {
            const ids = price?.seatIds?.find((id: any) => seatIds.includes(id));
            return ids === undefined;
        }
        return price.minTickets == null || price.minTickets === 0 ? price.qty === 0 : price.qty === 0 || price.qty <= price.minTickets;
    }
}
